"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RtfTableGrid = void 0;
var search_1 = require("@devexpress/utils/lib/utils/search");
var RtfTableGrid = (function () {
    function RtfTableGrid() {
        this.collection = [];
    }
    Object.defineProperty(RtfTableGrid.prototype, "first", {
        get: function () { return this.collection.length > 0 ? this[0] : -1; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RtfTableGrid.prototype, "last", {
        get: function () { return this.collection.length > 0 ? this[this.collection.length - 1] : -1; },
        enumerable: false,
        configurable: true
    });
    RtfTableGrid.prototype.binarySearchRight = function (right) {
        var index = search_1.SearchUtils.normedInterpolationIndexOf(this.collection, function (v) { return v; }, right);
        if (index <= 0)
            return index;
        var nextIndex = index + 1;
        while (nextIndex < this.collection.length && this.collection[nextIndex] == this.collection[index]) {
            index = nextIndex;
            nextIndex++;
        }
        return index;
    };
    RtfTableGrid.prototype.binarySearchLeft = function (right) {
        var index = search_1.SearchUtils.normedInterpolationIndexOf(this.collection, function (v) { return v; }, right);
        if (index <= 0)
            return index;
        var prevIndex = index - 1;
        while (prevIndex >= 0 && this.collection[prevIndex] == this.collection[index]) {
            index = prevIndex;
            prevIndex--;
        }
        return index;
    };
    return RtfTableGrid;
}());
exports.RtfTableGrid = RtfTableGrid;
